import ListSpecilaities from "../config/constants/specialties.json";

export function handleSpeciality(speciality: string, languageEn: boolean) {
  if (languageEn)
    return ListSpecilaities.find((el) => el.label === speciality)?.valueEN;
  return ListSpecilaities.find((el) => el.label === speciality)?.value;
}
